import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function PlombPage() {
  return <ServicePage data={servicesData.plomb} />;
}
